import { Post, ShopifyCartActions, GetUrlParams } from './nyb-utils.js';

const LS_KEY = 'nybWholesaleBox';

const getRandomNumber = () => {
    return Math.floor(Math.random() * 1000) + 1;
};

const isTrue = (value) => {
    return value === 'true';
};

class WholesaleBoxes {

    constructor(wrapper,settings) {        
        this.wrapper = wrapper;
        this.settings = settings;
        this.variants = this.settings.variants;
        this.prices = this.settings.prices;
        this.selectedProduct = null;
        this.selectedVariant = null;
        this.productSize = null;
        this.userIsEditing = false;
        this.cartItemProps = [];
        this.elements = this.getRequiredElements();
        this.getVariantIds();
        this.getVariantPrices();
        this.attachEvents();
        this.displayRepeatOrder();
        this.uniqueId = new Date().getTime().toString();
        this.checkUrlParams();
    };

    setUpItemsInBox = (boxLength,flavorLength) => {
        return new Array(boxLength).fill(undefined).map(() => new Array(flavorLength).fill(undefined));
    };

    getRequiredElements = () => {
        return {
            errorMessage: document.querySelector('.WholesaleProduct__Error'),
            steps: Array.from(document.querySelectorAll('[data-nyb-step]')),
            // large or mini
            sizeSelectors: document.querySelectorAll('[name="wholesale-product-size"]'),
            sizeCopyContainer: document.querySelectorAll('.WholesaleProduct__Language'),
            // number of dozens
            dozenSelectors: document.querySelectorAll('.WholesaleProduct__DozenSelector'),
            dozenSelector: undefined,
            // flavors
            flavorSelect: Array.from(document.querySelectorAll('[data-nyb-wholesale-box]')), 
            // order
            boxes: this.setUpItemsInBox(28,3),
            boxSelectors: document.querySelectorAll('.WholesaleProduct__Box'),
            price: document.querySelector('.product .price-list--product span.price span.money'),
            quantity: document.querySelector('input[name="quantity"]'),
            addToCart: document.querySelector('.WholesaleProduct__Footer input.addtocart'),
            repeatOrder: document.getElementById('wholesale-repeat-order'),
            tab: document.querySelector('div[data-et-handle="tabs-info"] .easytabs-content-holder.prose'),
            query: {
                flavorSelect: '.WholesaleProduct__Flavors .nyb-select'
            }
        }
    };

    getVariantBasedOnSelectedIndex = (selector) => {
        return selector.querySelector(`option[value="${selector.value}"]`).index;
    };

    getVariantIds = () => {
        
        const availableVariants = {};

        if(!this.variants) { 
            return false;
        };
        
        for(let key in this.variants) {
            availableVariants[key] = this.variants[key].split(',').map(variantId => Number(variantId)).slice(0,-1);
        };

        this.variants = availableVariants;
    };

    getVariantPrices = () => {
        
        const availableVariantPrices = {};

        if(!this.prices) { 
            return false;
        };
        
        for(let key in this.variants) {
            availableVariantPrices[key] = this.prices[key].split(',').map(price => Number(price)).slice(0,-1);
        };

        this.prices = availableVariantPrices;
    };

    attachEvents = () => {
        this.elements.sizeSelectors.forEach(select => {
            select.addEventListener('change', this.handleProductSize);
        });
        this.elements.flavorSelect.forEach(select => {
            select.addEventListener('change', this.handleFlavorChange);
        });
        this.elements.dozenSelectors.forEach(select => {
            select.addEventListener('change', this.handleDozenSelector);
        });
        this.elements.addToCart.addEventListener('click', this.handleAddToCart);
        this.elements.repeatOrder?.addEventListener('click', this.handleRepeatOrder);
    };

    getDozenSelector = (size) => {
        return document.getElementById(`wholesale-${size}-dozens`);
    };

    getInputWrapper = (element) => {
        return element.parentElement;
    };

    hideElements = (elements) => {
        elements.forEach(element => {
            this.getInputWrapper(element).dataset.nybShow = false;
        });
    };

    updateSelectText = (event) => {
        //event.target.parentElement.querySelector('.selected-text').innerText = event.target.querySelector(`option[value="${event.target.value}"]`).innerText.trim();
    };

    updateSelectError = (event) => {
        event.target.parentElement.dataset.nybError = (event.target.value === '');
    };

    updatePrice = (boxes) => {
        this.elements.price.dataset.nybShow = true;
        this.elements.price.innerText = `$${((boxes * this.selectedPrice)/100).toFixed(2)}`;
    };

    hidePrice = () => {
        this.elements.price.dataset.nybShow = false;
        this.elements.price.innerText = "";
    };

    displaySizeLanguage = () => {

        const descriptionToDisplay = Array.from(this.elements.sizeCopyContainer).find(description => description.dataset.size === this.selectedProduct);

        if (descriptionToDisplay) {
            this.elements.tab.innerHTML = descriptionToDisplay.innerHTML;
        }

        // this.elements.sizeCopyContainer.forEach(container => {
        //     container.dataset.nybShow = container.dataset.size === this.selectedProduct;
        // });
    };

    handleFlavorChange = (event) => {
        const [boxIndex, flavorIndex] = [Number(event.target.dataset.nybWholesaleBox), Number(event.target.dataset.nybWholesaleBoxFlavor)];
        this.elements.boxes[boxIndex-1][flavorIndex-1] = event.target.value;
        //this.updateSelectText(event);
        this.updateSelectError(event);
    };

    selectVariant = (element) => {
        try {

            

            const index = this.getVariantBasedOnSelectedIndex(element);

            this.selectedVariant = this.variants[this.selectedProduct][index];
            this.selectedPrice = this.prices[this.selectedProduct][index];

            if(!this.selectedVariant || !this.selectedPrice) {
                console.error("Wholesale Product: No variant found. Please check the variant settings.");
            }
        }
        catch(error) {
            console.error(error);
        }   
    };

    showStep = (step) => {
        this.elements.steps.forEach(element => {
            // step one is visible it does not hide any more 
            if(element.dataset.nybStep === step.toString()) {
                element.dataset.nybShow = true;
            }
        });
    };

    handleProductSize = (event) => {
        // must be identical to the setting variant key: large or mini
        this.selectedProduct = event.target.value;
        this.hidePrice();
        this.displaySizeLanguage();
        this.showStep(2);
        this.hideElements(this.elements.dozenSelectors);
        this.elements.dozenSelector = this.getDozenSelector(event.target.value);
        this.getInputWrapper(this.elements.dozenSelector).dataset.nybShow = true;
        this.productSize = Number(this.elements.dozenSelector.value);
        // this.selectVariant(this.elements.dozenSelector);
        this.updateNumberOfBoxes(this.productSize);
        this.updateFlavors();
    };

    handleDozenSelector = (event) => {
        this.updateSelectText(event);
        this.selectVariant(event.target);
        this.productSize = Number(event.target.value);
        this.updateNumberOfBoxes(event.target.value);
        this.updatePrice(event.target.value);
        this.showStep(3);
        this.showStep(4);
    };

    handleAddToCart = (event) => {
        this.addToCart();
        event.preventDefault();
    };

    handleRepeatOrder = (event) => {
        const serverOrder = window.nybLastServerOrder;
        if (serverOrder?.items?.length) {
            this.repeatOrder(serverOrder);
        } else {
            const lastProduct = localStorage.getItem(LS_KEY);
            if (lastProduct) this.repeatOrder(JSON.parse(lastProduct));
        }
        event.preventDefault();
    }
    
    resetBox = (boxIndex) => {
        this.elements.boxes[boxIndex] = new Array(3).fill(undefined);
    };

    updateNumberOfBoxes = dozens => {
        this.elements.boxSelectors.forEach((box, index) => {
        
            const displayBox = index < Number(dozens);

            box.dataset.nybShow = displayBox;

            // if large, hide extra boxes for mini
            box.querySelectorAll(this.elements.query.flavorSelect).forEach((flavorBox, index) => {
                switch (this.selectedProduct) {
                    case 'large': case 'flatLarge':
                        flavorBox.dataset.nybShow = index > 2 ? false : true;
                        break;
                    case 'mini':
                        flavorBox.dataset.nybShow = true;
                        break;
                }
            });

            if(!displayBox) {
                this.resetBox(index);
            }
        });
    };

    updateFlavors = () => {
        document.querySelectorAll(this.elements.query.flavorSelect).forEach(flavorBox => {
            // Fill the select with the available flavors
            flavorBox.querySelectorAll('select').forEach(flavor => {
                
                let newOptions = `<option value="">Select an option</option>`;

                this.settings.flavors[this.selectedProduct].split(', ').forEach(flavor => {
                    const parsedFlavor = flavor.replace(',','');
                    newOptions += `<option value="${parsedFlavor}">${parsedFlavor}</option>`;
                });

                flavor.innerHTML = newOptions;
            });
        });
    };

    addProductReference = (flavors) => {
        return {
            ...flavors,
            _wholesaleReference: this.uniqueId, 
            _wholesaleBoxId: this.uniqueId + getRandomNumber()
        }
    };
    
    processFlavors = (box) => {

        const boxFlavors = {};

        box.forEach((flavor, flavorIndex) => {
            boxFlavors[`${flavorIndex + 1}-${this.settings.sizes[this.selectedProduct]}`] = flavor;
        });

        return this.addProductReference(boxFlavors);
    };

    boxesAreValid = () => {
        return this.elements.boxes.slice(0,this.productSize).every(box => box.every(flavor => flavor !== undefined));
    };

    displayBoxError = () => {
        [...this.elements.boxSelectors].filter(box => isTrue(box.dataset.nybShow)).forEach(box => {
            box.querySelectorAll(this.elements.query.flavorSelect).forEach((flavorBox,index) => {
                if(isTrue(flavorBox.dataset.nybShow)) {
                    // check the selector
                    flavorBox.querySelectorAll('select').forEach(flavor => {
                        flavorBox.dataset.nybError = (flavor.value === '');
                    });
                }
            });
        });
    };

    displayRepeatOrder = () => {
        const hasLocal = !!localStorage.getItem(LS_KEY);
        const hasServer = !!(window.nybLastServerOrder?.items?.length);
        if ((hasLocal || hasServer) && this.elements.repeatOrder) {
            this.elements.repeatOrder.dataset.nybShow = true;
        }
    };

    handleError = () => {
        this.displayBoxError();
        this.elements.errorMessage.innerText = "Please select all flavors for each box before adding to cart.";
        this.elements.errorMessage.dataset.nybShow = !this.boxesAreValid();
    };

    saveLastSelection = selection => {
        localStorage.setItem('nybWholesaleBox',JSON.stringify(selection));
    };

    addToCart = async () => {
        
        if(!this.productSize || !this.boxesAreValid() || !this.selectedVariant) {
            this.handleError();
            return false;
        };

        if(this.userIsEditing) {
            await this.updateCart();
            return false;
        }

        const boxSelection = {
            items: this.elements.boxes.slice(0,this.productSize).map(box => {
                return {
                    id: this.selectedVariant,
                    quantity: Number(this.elements.quantity.value),
                    properties: this.processFlavors(box)
                }
            })
        };

        // 1. add to cart
        await Post(ShopifyCartActions.add, boxSelection);
        // 2. save in user session
        this.saveLastSelection(boxSelection);
        // 3. redirect to cart
        window.location.href = '/cart';
    };

    repeatOrder = async (items) => {
         // 1. add to cart
         await Post(ShopifyCartActions.add, items);
         // 2. save in user session
         this.saveLastSelection(items);
         // 3. redirect to cart
         window.location.href = '/cart';
    };

    updateCart = async () => {
        
        if(!this.productSize || !this.boxesAreValid() || !this.selectedVariant) {
            this.handleError();
            return false;
        };
        
        // build the properties for each box
        const boxSelectionProperties = this.elements.boxes.slice(0,this.productSize).map((box,index) => {

            const properties = this.processFlavors(box);

            properties._wholesaleReference = this.cartItemProps[index]._wholesaleReference;
            properties._wholesaleBoxId = this.cartItemProps[index]._wholesaleBoxId;

            return properties;
        });

        // update each box
        const promises = boxSelectionProperties.map(selectionProps => {
            
            const itemIndex = wholesaleCart.items.findIndex(item => item.properties._wholesaleBoxId === selectionProps._wholesaleBoxId);

            if(item) {
                return Post(ShopifyCartActions.change, {
                    line: itemIndex + 1,
                    properties: selectionProps
                });
            }
        });
        
        try {
            // 1. add to cart
            await Promise.all(promises);
            // 2. redirect to cart
            window.location.href = '/cart';
        }
        catch(error) {
            console.error('Error updating cart:', error);
        }
    };

    handleEditFlavors = boxReference => {
        
        if(!wholesaleCart) {
            return false;
        }

        const items = wholesaleCart.items.filter(item => item.properties._wholesaleReference === boxReference);
        const productId = items[0].product_id;
        
        // flag to update instead of adding
        this.userIsEditing = true;

        // save props to update cart
        this.cartItemProps = items.map(item => item.properties);

        // select size
        this.elements.sizeSelectors.forEach(radio => {
            if(parseInt(radio.dataset.nybProductId) === productId) {
                this.handleProductSize({target: radio});
                radio.checked = true;
            }
        });

        // select dozens
        this.elements.dozenSelector.value = items.length;
        this.elements.dozenSelector.dispatchEvent(new Event('change'));
        this.handleDozenSelector({target: this.elements.dozenSelector});

        // select flavors -> item properties
        items.forEach((item, index) => {

            const flavors = Object.values(item.properties).filter(prop => prop !== item.properties._wholesaleReference && prop !== item.properties._wholesaleBoxId);
            
            this.elements.boxes[index] = flavors;
            this.elements.boxSelectors[index].querySelectorAll(this.elements.query.flavorSelect).forEach((flavorBox, flavorIndex) => {
                if(flavors[flavorIndex]) {
                    flavorBox.querySelector('select').value = flavors[flavorIndex];
                    flavorBox.querySelector('select').dispatchEvent(new Event('change'));
                }
            });
        });
    };

    checkUrlParams = () => {

        const params = GetUrlParams();

        if (params.type) {
            // select large, mini or flats
            const type = params.type.includes("flat") ? "flatLarge" : params.type.toLowerCase();
            this.elements.sizeSelectors.filter(selector => selector.value === type)?.click;
            //document.querySelector(`[name="wholesale-product-size"][value="${type}"`)?.click();
        }
        
        if(params.ref) {
            this.handleEditFlavors(params.ref);
        }
    };
};

document.addEventListener('DOMContentLoaded', () => {
    
    const wholesaleBoxes = document.querySelector('[data-nyb="WholesaleBoxes"]');

    if(!wholesaleBoxes) {
        return false;
    }

    new WholesaleBoxes(wholesaleBoxes, wholesaleBoxes.dataset.nybSettings ? JSON.parse(wholesaleBoxes.dataset.nybSettings) : {});
});